// 3-row × 2-col grid — sidebar spans top two rows, statusbar spans both
// columns. Mirrors the prototype's `shell.jsx` layout one-for-one.

import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { StatusBar } from './StatusBar';

export function AppShell() {
  return (
    <div
      className="h-screen overflow-hidden grid"
      style={{
        gridTemplateColumns: '212px 1fr',
        gridTemplateRows: '54px 1fr 30px',
      }}
    >
      <div className="row-[1/3] col-[1] min-h-0 flex flex-col">
        <Sidebar />
      </div>
      <div className="row-[1] col-[2]">
        <Topbar />
      </div>
      <main className="row-[2] col-[2] overflow-y-auto min-h-0">
        <Outlet />
      </main>
      <div className="row-[3] col-[1/3]">
        <StatusBar />
      </div>
    </div>
  );
}
